/* Variant facts are rendered by Liquid, never inferred from option names. The main form is the only source of
   selection; a Configure dialog for the same product must not change the page. Reconnects cover tab moves and
   section replacement, while an empty or unknown selection removes the previous facts. */
(() => {
  if (customElements.get('cq-variant-specifications')) return;

  customElements.define('cq-variant-specifications', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-cq-spec-current]');
      if (!this.content) return;
      this.templates = new Map([...this.querySelectorAll('template[data-cq-spec-variant]')]
        .map(template => [template.dataset.cqSpecVariant, template]));
      this.current = null;
      this.cqEvents?.abort();
      this.cqEvents = new AbortController();
      const options = { signal: this.cqEvents.signal };
      document.addEventListener('shopify:section:load', () => this.bindForm(), options);
      window.addEventListener('pageshow', () => this.sync(), options);
      this.bindForm();
    }

    disconnectedCallback() {
      this.cqEvents?.abort();
      this.formEvents?.abort();
      this.observer?.disconnect();
      this.cqEvents = this.formEvents = this.observer = null;
    }

    bindForm() {
      this.formEvents?.abort();
      this.observer?.disconnect();
      this.form = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
      if (!this.form) {
        // Preserve the server-rendered selection when there is no enhanced purchase form.
        this.show(this.dataset.selected);
        return;
      }
      this.formEvents = new AbortController();
      const options = { signal: this.formEvents.signal };
      this.form.addEventListener('change', event => {
        if (event.target.name === 'id') this.sync();
      }, options);
      const picker = this.form.closest('cq-purchase-options');
      picker?.addEventListener('cq:variant-change', event => {
        if (event.target === picker) this.show(event.detail?.variant?.id);
      }, options);
      this.observer = new MutationObserver(records => {
        const changesId = records.some(record => record.type === 'attributes'
          ? record.target.getAttribute('name') === 'id'
          : [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1
            && (node.matches('[name="id"]') || node.querySelector('[name="id"]'))));
        if (changesId) this.sync();
      });
      this.observer.observe(this.form, { subtree: true, attributes: true, attributeFilter: ['value', 'disabled'], childList: true });
      this.sync();
    }

    sync() {
      if (!this.form?.isConnected) return;
      const input = this.form.querySelector('[name="id"]');
      this.show(input && !input.disabled ? input.value : null);
    }

    show(id) {
      const key = id == null ? '' : String(id);
      const template = this.templates.get(key);
      if (this.current === key && this.hidden === !template) return;
      this.current = key;
      this.hidden = !template;
      this.content.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
      if (!template) return;
      // SSR already has complete values; add locale grouping and remove insignificant decimal zeroes in browsers.
      let format;
      try { format = new Intl.NumberFormat(document.documentElement.lang || undefined, { maximumFractionDigits: 20 }); }
      catch (_) { return; }
      this.content.querySelectorAll('[data-cq-spec-number]').forEach(node => {
        const value = Number(node.dataset.cqSpecNumber);
        if (Number.isFinite(value)) node.textContent = format.format(value);
      });
    }
  });
})();
